import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class AlertModalComponent {
  @Input() message: string = '';
  @Input() buttonText: string = 'Volver a intentar';
  @Input() isSuccess: boolean = false;
  @Output() closeModal = new EventEmitter<void>();
  @Output() actionClick = new EventEmitter<void>();

  onClose(): void {
    this.closeModal.emit();
  }

  onAction(): void {
    this.actionClick.emit();
  }
}
